"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = isValidColor;

var _polished = require("polished");

function isValidColor(color) {
  if (!color) return false;

  try {
    (0, _polished.parseToRgb)(color);
    return true;
  } catch (e) {
    return false;
  }
}